export const SET_EMAILSTATUSTEMPLATE = 'RSVP/SET_EMAILSTATUSTEMPLATE'
export const SET_EMAILSTATUSTEMPLATES = 'RSVP/SET_EMAILSTATUSTEMPLATES'
